<template>
  <div class="myapply">
    <div class="title">我的申请</div>
    <div class="collectlist-box" v-if="collectList && collectList.length">
      <div
        v-for="(item, idx) in collectList"
        :key="idx"
        :class="[
          'collect-item',
          item.save_data &&
          item.save_data[0] &&
          item.save_data[0].goods_info_remark_005 == '502'
            ? 'down'
            : '',
        ]"
        @click="handleToDetail(item)"
      >
        <div class="cover-box">
          <img
            class="cover-img"
            :src="item.save_data[0].goods_main_image"
            alt="cover"
          />
          <div
            :class="['dealstatus-box', item.ship_state == 1 ? 'isnotdeal' : '']"
          >
            {{ item.ship_state | showStatus }}
          </div>
          <img
            v-if="
              item.save_data &&
              item.save_data[0] &&
              item.save_data[0].goods_info_remark_001
            "
            class="icon-play"
            @click.stop="handlePlayVideo(item)"
            src="@/assets/icon_play.png"
            alt="play"
          />
        </div>
        <div class="name-box">{{ item.save_data[0].goods_name }}</div>
        <div class="description-box">
          {{ item.save_data[0].goods_dec }}
        </div>
        <div class="time-complete-box">
          <el-button
            class="custom-button btn-border btn-complete"
            @click.stop="handleCompleteInfo(item)"
            >完善资料</el-button
          >
          <div>{{ item.time_order }}</div>
        </div>
        <div class="downmask" @click.stop="handleDownmask(item)"></div>
        <!-- <div class="btn-delete" @click.stop="handleDelItem(item, idx)">
          <i class="el-icon-delete"></i>
        </div> -->
      </div>
    </div>
    <div class="pagination-box" v-if="collectList.length">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
    <NoneData v-if="!collectList || !collectList.length"></NoneData>
    <VideoPlay ref="compVideoPlay" :videoSrc="videoSrc"></VideoPlay>

    <DialogApplyInfo
      ref="dialogApplyInfo"
      :title="'完善资料'"
      :goodData="goodData"
      :id="applyinfoid"
    ></DialogApplyInfo>
  </div>
</template>
<script>
import NoneData from "@/components/NoneData";
import VideoPlay from "@/components/VideoPlay";
import DialogApplyInfo from "@/components/dialog/ApplyInfo";
import pageCommon from "@/utils/pagecommon";
import caseApi from "@/api/case";
import lodash from "lodash";
export default {
  name: "MyApply",
  components: {
    VideoPlay,
    DialogApplyInfo,
    NoneData,
  },
  created() {
    let _this = this;
    _this.getMyApplies();
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 5);
  },
  data() {
    return {
      collectList: [],
      currentPage: 1,
      pageSize: 9,
      total: 0,
      videoSrc: "",
      goodData: null,
      isRequesting: false,
      applyinfoid: 0,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      return userShopInfo;
    },
  },
  filters: {
    showStatus: function (val) {
      if (val == 1) {
        return "未受理";
      }
      if (val == 4) {
        return "已受理";
      }
    },
  },
  methods: {
    getMyApplies: function () {
      let _this = this;
      console.log(_this.userInfo);
      let requestData = {
        idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        buyer_id: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "myApply", requestData).then(
        (res) => {
          _this.collectList = res && res.order_list ? res.order_list : [];
          _this.total = res.order_count;
        },
        (err) => {
          _this.collectList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handleToDetail: function (item) {
      let _this = this;
      if (item && item.save_data && item.save_data.length) {
        _this.$router.push({
          path: "/casedetail",
          query: {
            id: item.save_data[0].id_public_goods_info,
            type: "-2",
          },
        });
      } else {
        _this.$message.error("数据异常!");
      }
    },
    handleCurrentChange: function (val) {
      let _this = this;
      _this.currentPage = val;
      _this.getMyApplies();
    },
    handleDelItem: function (item, idx) {
      let _this = this;
      _this.delMyApplyMain(item);
      // _this.collectList.splice(idx, 1);
    },
    handleDownmask: function (item) {
      let _this = this;
      _this.$message.error("该案例已下架");
      return;
    },
    delMyApplyMain: function (item) {
      let _this = this;
      let id_public_goods_order_record = item.id_public_goods_order_record;
      let requestData = {
        id_public_goods_order_record: id_public_goods_order_record,
        ship_state: 5,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "delMyApply", requestData).then(
        (res) => {
          _this.isRequesting = false;
          _this.currentPage = 1;
          _this.getMyApplies();
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handlePlayVideo: function (item) {
      let _this = this;

      _this.videoSrc = item.save_data[0].goods_info_remark_001;
      _this.$refs.compVideoPlay.showDialog = true;
    },
    handleCompleteInfo: function (item) {
      let _this = this;
      _this.$refs["dialogApplyInfo"].showDialog = true;
      _this.applyinfoid = item.id_public_goods_order_record;
      _this.$nextTick(() => {
        _this.goodData = lodash.cloneDeep(item);
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.myapply {
  margin-left: 40px;
  height: 100%;
  overflow: hidden;
  .title {
    font-size: 26px;
    font-family: "SourceHanSansCN";
    color: rgb(34, 34, 34);
    font-weight: bold;
    margin-top: 40px;
    text-align: left;
  }
  .collectlist-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    .collect-item {
      position: relative;
      width: 314px;
      margin-right: 24px;
      cursor: pointer;
      .cover-box {
        position: relative;
        width: 314px;
        height: 236px;
        border-radius: 4px;
        box-sizing: border-box;
        overflow: hidden;
        // margin-top: 16px;

        .cover-img {
          width: 314px;
          height: 240px;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .dealstatus-box {
          position: absolute;
          left: 1px;
          bottom: 1px;
          background-color: rgba(7, 6, 11, 0.8);

          width: 72px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-radius: 4px;

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;

          &.isnotdeal {
            color: #ec4040;
          }
        }
        .icon-play {
          position: absolute;
          cursor: pointer;
          width: 50px;
          height: 50px;
          background: #07060b;
          box-shadow: 0px 2px 8px 0px rgba(22, 14, 46, 0.58);
          opacity: 0.8;
          border-radius: 50%;
          right: 16px;
          bottom: 16px;
          box-sizing: border-box;
        }
      }
      .name-box {
        position: relative;
        padding-top: 25px;
        padding-bottom: 15px;
        box-sizing: border-box;

        width: 314px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        text-align: left;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 800;

        color: #222222;
        line-height: 20px;
      }
      .description-box {
        width: 100%;
        height: 42px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
        -webkit-line-clamp: 2; //这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。此处为2行
        word-wrap: break-word; //允许单词内断句，首先会尝试挪到下一行，看看下一行的宽度够不够，不够的话就进行单词内的断句
        color: #000000;
        text-align: left;
        margin-bottom: 16px;
        box-sizing: border-box;

        font-size: 18px;
        font-family: "SourceHanSansCN";
        color: rgb(51, 51, 51);

        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
      }
      .time-complete-box {
        width: 100%;
        font-size: 14px;
        font-family: "SourceHanSansCN";
        color: rgb(153, 153, 153);
        margin-bottom: 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn-complete {
          width: 70px;
          height: 28px;
          line-height: 28px;
          font-size: 14px;
        }
      }
      .btn-delete {
        position: absolute;
        width: 24px;
        height: 24px;
        background: rgba(7, 6, 11, 0.5);
        border-radius: 2px;
        right: 1px;
        top: 1px;
        display: none;
        .el-icon-delete {
          color: #ffffff;
          font-size: 22px;
        }
      }
      .downmask {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.5);
        display: none;
      }
      &:hover {
        .name-box {
          color: rgb(235, 51, 58);
        }
        .btn-delete {
          display: block;
        }
      }
      &.down {
        .downmask {
          display: block;
        }
        &:hover {
          .name-box {
            color: #222222;
          }
        }
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .pagination-box {
    position: relative;
    width: 100%;
    margin-bottom: 40px;
    margin-top: 10px;
    /deep/ .btn-prev {
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      height: 35px;
      line-height: 35px;
      // border: 1px solid #000000;
      border: 1px solid #e3e3e3;
      margin: 0;
      box-sizing: border-box;
      color: rgb(34, 34, 34);

      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #222222;
      span {
        display: inline-block;
        font-size: 13px;
        min-width: 35.5px;
        height: 353px;
        line-height: 35px;
        vertical-align: top;
        box-sizing: border-box;
      }
      &:disabled {
        background: rgb(238, 238, 238);
        color: rgb(189, 189, 189);
      }
    }
    /deep/ .btn-next {
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      height: 35px;
      line-height: 35px;
      border: 1px solid #000000;
      margin: 0;
      box-sizing: border-box;
      margin-left: 15px;
      color: rgb(34, 34, 34);
      border: 1px solid #e3e3e3;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #222222;
      span {
        display: inline-block;
        font-size: 13px;
        min-width: 35.5px;
        height: 353px;
        line-height: 35px;
        vertical-align: top;
        box-sizing: border-box;
      }
      &:disabled {
        background: rgb(238, 238, 238);
        color: rgb(189, 189, 189);
      }
    }
    /deep/ .el-pager {
      li {
        margin: 0;
      }
      .number {
        width: 35px;
        height: 35px;
        line-height: 35px;
        margin: 0;
        box-sizing: border-box;
        text-align: center;
        // border: 1px solid #000000;
        margin-left: 10px;
        color: rgb(34, 34, 34);
        border: 1px solid #e3e3e3;

        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #222222;
        &.active {
          background: rgb(236, 64, 64);
          color: #ffffff;
        }
      }
      .btn-quickprev {
        width: 35px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        margin-left: 10px;
        &.el-icon-d-arrow-left {
          color: inherit;
          &::before {
            content: "\e794";
          }
        }
      }
      .btn-quicknext {
        width: 35px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        margin-left: 10px;
        &.el-icon-d-arrow-right {
          color: inherit;
          &::before {
            content: "\e794";
          }
        }
      }
    }
  }
}
</style>
